import { GridColDef } from "@mui/x-data-grid";
import React from "react";

/**
 * Column definitions for the clients data table.
 * These columns define the structure and appearance of the table that displays client information.
 * 
 * @type {GridColDef[]}
 * @property {string} name - The name of the client
 * @property {string} sap - The SAP identifier of the client
 * @property {string} aquaResponsibleUsers - The responsible users for the client in Aqua
 * @property {string} drinking_water_mibi_phase - The drinking water microbiological phase
 */

/**
 * Get column definitions for the clients data table.
 * Conditionally includes the DW Mibi phase column based on user permissions.
 * 
 * @param {boolean} canViewDwMibiPhase - Whether the user can view DW Mibi phase
 * @returns {GridColDef[]} Array of column definitions
 */
export const getColumns = (canViewDwMibiPhase: boolean = false): GridColDef[] => {
  const columns: GridColDef[] = [
    {
      field: "name",
      headerName: "Name",
      flex: 1,
    },
    {
      field: "sap",
      headerName: "SAP",
      flex: 1,
    },
    {
      field: "aquaResponsibleUsers",
      headerName: "Verantwortlicher",
      flex: 1,
    }
  ];

  // Conditionally add DW Mibi phase column in the middle
  // if (canViewDwMibiPhase) {
  //   columns.push({
  //     field: "drinking_water_mibi_phase",
  //     headerName: "dwmibiphase",
  //     flex: 1,
  //     renderCell: (params: any) => {
  //       const phase = params.value;
  //       if (!phase) return "-";
  //       return React.createElement(
  //         "span",
  //         {
  //           style: {
  //             padding: "4px 8px",
  //             borderRadius: "4px",
  //             backgroundColor: "#e3f2fd",
  //             fontSize: "0.875rem",
  //             fontWeight: "500",
  //             display: "inline-block"
  //           }
  //         },
  //         phase
  //       );
  //     }
  //   });
  // }

  return columns;
};

// Backward compatibility - default columns without DW Mibi phase
export const columns: GridColDef[] = getColumns(false);
